import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=1c66e6fd"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoice.vue?vue&type=style&index=0&id=1c66e6fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports